import { Users } from "lucide-react";
import type { ReactElement } from "react";
import { VideoIcon } from "@/components/custom/video-theme";
import type { PricingTab } from "@/lib/pricing-navigation";

export type PricingTabDescriptor = {
	value: PricingTab;
	label: string;
	iconKey: string;
	renderIcon: (className?: string) => ReactElement;
};

export const PRICING_TABS: readonly PricingTabDescriptor[] = [
	{
		value: "reach",
		label: "Views",
		iconKey: "play",
		renderIcon: (className = "") => (
			<VideoIcon
				variant="play"
				size="xs"
				color="#dc2626"
				className={className}
			/>
		),
	},
	{
		value: "growth",
		label: "New Sub",
		iconKey: "users",
		renderIcon: (className = "") => (
			<Users
				className={className ? `${className} text-red-600` : "text-red-600"}
			/>
		),
	},
	{
		value: "engagement",
		label: "Watch Hour",
		iconKey: "clock",
		renderIcon: (className = "") => (
			<VideoIcon
				variant="clock"
				size="xs"
				color="#dc2626"
				className={className}
			/>
		),
	},
	{
		value: "editing",
		label: "Editing",
		iconKey: "scissors",
		renderIcon: (className = "") => (
			<VideoIcon
				variant="scissors"
				size="xs"
				color="#dc2626"
				className={className}
			/>
		),
	},
	{
		value: "audit",
		label: "Audit",
		iconKey: "clipboard",
		renderIcon: (className = "") => (
			<VideoIcon
				variant="clipboard"
				size="xs"
				color="#dc2626"
				className={className}
			/>
		),
	},
	{
		value: "targeted",
		label: "Targeted Ads",
		iconKey: "target",
		renderIcon: (className = "") => (
			<VideoIcon
				variant="target"
				size="xs"
				color="#dc2626"
				className={className}
			/>
		),
	},
] as const;
